import { useState } from 'react'

import { PayrollConceptFragment } from 'generated/resources/graphql'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { useFilterProvider } from 'modules/finance/components/FinancialWorkspace/Providers/FiltersProvider'
import { useFinancialWorkspace } from 'modules/finance/components/FinancialWorkspace/Providers/Provider'
import { ConceptSelector } from 'modules/finance/components/FinancialWorkspace/components/ConceptSelector'

interface PayrollLineFilterProps {
  defaultOpen?: boolean
  defaultConceptIds?: number[]
}

export const PayrollLineFilter = ({ defaultOpen, defaultConceptIds }: PayrollLineFilterProps) => {
  const { state, dispatch } = useFinancialWorkspace()
  const { saveFilters } = useFilterProvider()
  const [selectedConcepts, setSelectedConcepts] = useState<PayrollConceptFragment[] | undefined>(
    undefined
  )

  const onValueChange = (value: PayrollConceptFragment[]) => {
    const payload = value.map((o) => o.id)
    dispatch({ type: 'SET_CONCEPT_IDS', payload })
    saveFilters('conceptIds', payload)
    setSelectedConcepts(value)
  }

  // set default value as current value if there is no current value
  useUnsafeEffect(() => {
    if (defaultConceptIds?.length && !state.conceptIds?.length) {
      dispatch({ type: 'SET_CONCEPT_IDS', payload: [...defaultConceptIds] })
    }
  }, [dispatch, defaultConceptIds, state.conceptIds])

  return (
    <ConceptSelector
      defaultConceptIds={state.conceptIds || []}
      selectedConcepts={selectedConcepts}
      onValueChange={onValueChange}
      label={i18n.t('finance.financial_workspace.payroll.filters.concepts')}
      defaultOpen={defaultOpen}
    />
  )
}
